<template>
  <b-card>
    <grupo-usuario-list
      :carregar="carregar"
      :novo="adicionar"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
    />
  </b-card>
</template>

<script>
import api from './shared/services/api'

export default {
  name: 'GrupoUsuarioVisualizacao',
  components: {
    GrupoUsuarioList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        { label: 'Nome', field: 'nome', editable: true },
        { label: 'Externo', field: 'externo', type: 'Boolean' },
        { label: 'Descrição', field: 'descricao', type: 'LargeText' }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getAll(page, pageSize, filtros)
    },
    adicionar() {
      this.$router.push({ name: 'add-grupousuario' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-grupousuario', params: { id: value.id } })
    },
    remover(values) {
      if (values && values.length === 1) {
        return new Promise((resolve, reject) => {
          api.delete(values[0].id)
            .then(() => {
              resolve(false)
            })
            .catch(err => {
              reject(err)
            })
        })
      }

      const idList = values.map(map => map.id)
      return new Promise((resolve, reject) => {
        api.deleteAll({ identificadores: idList })
          .then(() => {
            resolve(false)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
  },
}
</script>
